<template>
  <ul>
    <li class="site_li1">
      <b>您想办的是一场什么活动</b>
      <el-select v-model="siteData.activeType" placeholder="请选择" style='width:3.4rem' size="mini">
        <el-option v-for="text in activityContentOption" :key="text" :label="text" :value="text"></el-option>
      </el-select>
    </li>
    <li class="site_li2">
      <b style="margin-right: 0.1rem;">参加人数？</b>
      <p>
        <el-radio v-model="siteData.peopleType" :label="1" style="margin-right: 0.15rem;">有相对准确的人数</el-radio>
        <span v-show="siteData.peopleType==1">
          <el-input v-model="siteData.peopleNumber" placeholder="请填写" style="width:1rem" size="mini"
            @input="siteData.peopleNumber=siteData.peopleNumber.replace(/[^\d]/g,'')">
          </el-input>&nbsp;&nbsp;人
        </span>
        <el-radio v-model="siteData.peopleType" :label="2" style="margin-right: 0.15rem;">有大致的人数</el-radio>
        <span v-show="siteData.peopleType==2">
          <el-select v-model="siteData.peopleNumRange" placeholder="请选择" style='width:1.4rem' size="mini">
            <el-option v-for="text in peopleNumRangeOption" :key="text" :label="text" :value="text"></el-option>
          </el-select>
        </span>
      </p>
    </li>
    <li class="site_li3">
      <div>
        <el-input v-model="siteData.budgetPrice" placeholder="亲，您的大致预算是？" style='width:1.75rem' size="mini"></el-input>
        <currency-autocomplete :obj="siteData" :sizeType="'small'" :styleStr="'width:0.7rem;margin-left:0.1rem'"></currency-autocomplete>
        <span>&nbsp;以内</span>
      </div>
      <p class="site_li3P"><span>请选择预算包含的服务</span></p>
    </li>
    <li class="labelmodular">
      <ul>
        <li v-for="(data,index) in labelOption" :key="index">
          <p class="firstP">{{data.name}}</p>
          <p class="otherP">
            <span v-for="(lab,ind) in data.value" :key="ind" @click="siteCheckLab(data.name,lab,siteData)"
              :class="siteData.containServiceMap&&siteData.containServiceMap[data.name].indexOf(lab)!=-1?'checkSpan':''">{{lab}}</span>
          </p>
        </li>
      </ul>
    </li>
    <li class="site_li4">
      <b>您的备注</b>
      <el-input v-model="siteData.remarks" placeholder="您还有其他什么特别要求？" size="mini" style="width:4.4rem"></el-input>
    </li>
  </ul>
</template>

<script>
import CurrencyAutocomplete from '../../common/currencyAutocomplete.vue'
export default {
  props:{
    siteData:{
      type:Object,
      default:()=>{return {}}
    }
  },
  components:{CurrencyAutocomplete},
  data(){
    return{
      activityContentOption: ['活动竞技', '电影/摄影摄像', '产品展示', '一般会议', '一般会议&大型会议', '私人活动', '舞会', '圣诞节', '活动竞技&激励活动', '年会', '答谢会', 'Outing/会奖', '其他'],
      peopleNumRangeOption: ['10人以下', '10-30人', '30-60人', '60-100人', '100-200人', '200-300人', '300-500人', '500-1000人', '1000人以上'],
      labelOption: [{
        name: '场地',
        value: ['场地租赁'],
      }, {
        name: '人员',
        value: ['礼仪', '安保', '摄影摄像', '翻译', '保洁', '主持人', '演出人员', '控场/导演'],
      }, {
        name: '设备',
        value: ['场地设计及搭建', '投影仪', 'LED', '话筒', '音响', '舞台', '演讲台', '签到台'],
      }, {
        name: '策划',
        value: ['团建策划', '教授联系', '联系拜访/座谈', '客户答谢活动策划'],
      }, {
        name: '宣传',
        value: ['活动媒体邀约', '媒体发布'],
      }, {
        name: '物料',
        value: ['品牌露出材料制作', '会议桌牌', '房间欢迎卡', '会场指示牌', '签到板', '纸笔'],
      }, {
        name: '餐饮',
        value: ['茶歇', '矿泉水', '自助午餐', '自助晚餐', '围桌午餐', '围桌晚宴',],
      }, {
        name: '旅游',
        type: 'travel',
        value: ['机票', '火车/轮船', '酒店', '包车', '景点', '美食', '导游', '签证',],
      }],
    }
  },
  methods:{
    siteCheckLab (type, lab,item) {
      if (item.containServiceMap[type].indexOf(lab) != -1) {
        item.containServiceMap[type].splice(item.containServiceMap[type].indexOf(lab), 1);
      } else {
        item.containServiceMap[type].push(lab);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.site_li1{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.site_li2{
  display: flex;
  align-items: center;
  margin-top: 0.1rem;
}
.site_li3{
  display: flex;
  margin-top: 0.1rem;
  justify-content: space-between;
  border-bottom: 2px solid #e27249;
  .site_li3P{
    height: 0.34rem;
    line-height: 0.34rem;
    width: 1.6rem;
    color: #fff;
    background: #e27249;
    text-align: center;
    span{
      font-size: 0.12rem;
    }
  }
}
.labelmodular{
  ul{
    li{
      margin: 7px 0;
      display: flex;
      .firstP{
        color: #e3734a;
        width: 0.5rem;
        display: flex;
        align-items: center;
      }
      .otherP{
        width: 5.68rem;
        span{
          display: inline-block;
          background: #edf1f2;
          padding: 0.05rem 0.1rem;
          margin: 3px;
          cursor: pointer;
        }
        .checkSpan{
          background: #e65019;
          color: #fff;
        }
      }
    }
  }
}
.site_li4{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>